<script setup>
import { watchEffect } from "vue";
import { useRouter } from "vue-router";
import { auth } from "@/plugins/keycloak";

const router = useRouter();

watchEffect(async () => {
    if (auth.isAuthenticated.value) {
        router.push({ name: "consultation" });
    }
    console.log(auth.isAuthenticated.value);
});
</script>
<template>
    <q-card class="welcome-box text-center q-pa-md q-mt-xl q-mx-auto">
        <p class="text-h3">Bienvenue</p>

        <p>
            <q-btn :to="{ name: 'signin', query: { redirectTo: '/consultation' } }" color="primary" class="full-width"
                >Login edu-id</q-btn
            >
        </p>
        <p>
            En cas de problème de connexion, <br />veuillez prendre contact avec l'équipe SEAE<br />
            <br />Vous trouverez les contacts de l'équipe Bachelor
            <a href="https://www.unil.ch/hec/bachelors/contacts" target="_blank" rel="noreferrer"> ici </a>
            et de l'équipe Master
            <a href="https://www.unil.ch/hec/contact/graduate-school-masters" target="_blank" rel="noreferrer"> ici </a
            >.
        </p>
    </q-card>
</template>
<style scoped>
.welcome-box {
    max-width: 600px;
}
</style>
